import { t } from 'i18next';
import { SCRIPT_REGEX } from '../../../../integrations/jira/utils/JiraUtils';

export function number({ msg = t('validators.type.number') } = {}) {
  return (value: any) => {
    if (!Number.isFinite(value)) {
      return msg;
    }
    return true;
  };
}

export function url({ msg = t('validators.type.url') } = {}) {
  return (value: any) => {
    try {
      // The `URL` constructor raises on invalid URLs...
      const url = new URL(value);
      // ... but it allows all valid protocols: check for http explicitly
      if (url.protocol === 'http:' || url.protocol === 'https:') {
        return true;
      }
      return msg;
    } catch {
      return msg;
    }
  };
}

export function regex(regexp: RegExp, { msg = t('validators.type.regex') } = {}) {
  return (value: string) => {
    if (!value.match(regexp)) {
      return msg;
    }

    return true;
  };
}

// Jira API will fail if there is a trailing / at the end of the url
// This could be useful for future integrations
export function urlWithoutTrailingSlash({ msg = t('validators.url.trailingSlash') } = {}) {
  return (value: any) => {
    // Checking for the trailing slash and any non-word characters after that.
    if (/[/]\s*$/.test(value)) {
      return msg;
    }
    return true;
  };
}

//Validator for Jira issue collector script
export function script({ msg = t('jiraIssueCollector.inputError') } = {}) {
  return (value: any) => {
    if (SCRIPT_REGEX.test(value)) {
      return true;
    } else return msg;
  };
}
